export default {
  DEPENDENT_FORM_FIELD: 'dependentFormField',
  FILTERS: 'filters',
  FORM_FIELD_ACTION: 'formFieldAction'
};